<template>
  <a-card title="退款/售后" :bordered="false" :headStyle="{borderBottom:'0px'}">
    <a-form>
      <search-page-view
        :col="3"
        ref="pageList"
        :itemNames="['search_proId','search_proName','search_afterState', 'search_afterType','search_importDate','create_button',]"
        :columns="columns"
        :queryParams="queryParams"
        row-key="afterId"
        :enableSearch="false"
        :leftSpace="20"
        :requestPromise="loadPromise"
      >
        <a-form-item slot="search_proId" label="商品ID" v-bind="formItemLayout">
          <a-input v-model="queryParams.proId" placeholder="请输入"></a-input>
        </a-form-item>
        <a-form-item slot="search_proName" label="商品名称" v-bind="formItemLayout">
          <a-input v-model="queryParams.proName" placeholder="请输入"></a-input>
        </a-form-item>
        <a-form-item slot="search_afterState" label="售后状态" v-bind="formItemLayout">
          <a-select
            style="width: 100%"
            v-model="queryParams.afterState"
            placeholder="请选择" allowClear
          >
            <a-select-option value="0">售后中</a-select-option>
            <a-select-option value="1">售后结束</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item slot="search_afterType" label="售后类型" v-bind="formItemLayout">
          <a-select
            style="width: 100%"
            v-model="queryParams.afterType"
            placeholder="请选择" allowClear
          >
            <a-select-option value="0">退款</a-select-option>
            <a-select-option value="1">退货退款</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item slot="search_importDate" label="售后日期" v-bind="formItemLayout">
          <a-range-picker @change="onDateChange" :value="selectedDate" style="width: 100%"/>
        </a-form-item>
        <a-form-item slot="create_button">
          <a-button style="margin-left: 30px" type="primary" @click="$refs.pageList.refresh(true)">查 询</a-button>
        </a-form-item>
        <template slot="operationName" slot-scope="rowItem">
          {{ rowItem.record.operationName ? rowItem.record.operationName : '--' }}
        </template>
        <span slot="action" slot-scope="rowItem">
          <a v-if="rowItem.record.afterState==0" @click="toSaleEvent(rowItem.record.afterId)">处理售后</a>
          <a v-if="rowItem.record.afterState==1" @click="toSaleEvent(rowItem.record.afterId)">查看售后记录</a>
        </span>
      </search-page-view>
    </a-form>
  </a-card>
</template>

<script>
export default {
  name: 'RefundList',//退款
  data() {
    return {
      selectedDate: undefined,
      queryParams: {
        afterState: this.$route.query.afterState ? this.$route.query.afterState : undefined
      },
      statusList: [],
      loadPromise: params => this.getRefundPromise(params),
      columns: [
        {
          title: 'ID',
          dataIndex: 'afterId'
        },
        {
          title: '售后内容',
          dataIndex: 'afterSaleDes'
        },
        {
          title: '售后类型',
          dataIndex: 'afterTypeStr'
        },
        {
          title: '关联订单',
          dataIndex: 'orderNo'
        },
        {
          title: '售后商品',
          dataIndex: 'orderProName'
        },
        {
          title: '售后时间',
          dataIndex: 'afterSaleCreateTime'
        },
        {
          title: '操作人',
          dataIndex: 'operationName',
          align: 'center',
          scopedSlots: { customRender: 'operationName' }
        },
        {
          title: '操作',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      formItemLayout: {
        labelCol: {
          xxl: { span: 6 },
          xl: { span: 7 },
          lg: { span: 8 },
          sm: { span: 9 },
          md: { span: 10 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 18 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 17 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 16 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 15 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 14 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      }
    }
  },
  mounted() {
  },
  activated() {
    let afterState = this.$route.query.afterState
    if (afterState != undefined && afterState != null) {
      this.queryParams.afterState = String(afterState)
      this.$refs.pageList.refresh(true)
    }
  },
  methods: {
    getRefundPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getOrderService().post('order/AfterSale/findOrderAfterSaleList', params)
    },
    //日期
    onDateChange(dates, dateStrArr) {
      this.selectedDate = dates
      this.queryParams.afterSaleTimeStart = dateStrArr[0]//出游开始日期
      this.queryParams.afterSaleTimeEnd = dateStrArr[1]//出游结束日期
    },
    toSaleEvent(id) {
      this.$router.push({
        name: 'RefundDetail',
        query: {
          afterId: id
        }
      })
    }
  }

}
</script>
<style lang="less">
.ant-btn + .ant-btn {
  margin-left: 10px;
}
</style>